module.exports = __webpack_public_path__ + "img/qx55-2025.2af6c58b.png";